import loadingUrl from '../assets/pay/loading.svg'
  import style from '../components/Tips/loading.module.css'
 
  /**以下为辅助函数**/
  /**
  * 得到loading效果的img元素
  * @param el 传入的dom元素
  */
  function getLoadingImg(el) {
    //查找图片中有data-role为loading的图片
    return el.querySelector('img[data-role=loading]');
  }
 
  /**
  * 创建一个加载loading图片的元素
  */
  function createLoadingImg() {
    const img = document.createElement('img');
    //添加data-role为loading的属性
    img.dataset.role = 'loading';
    //给创建的img元素添加图片地址
    img.src = loadingUrl;
    //给img添加className
    img.className=style.loading
    return img;
  }
 
 
  export default function (el, binding) {
      //获取当前的有loading效果的img元素
      const curImg=getLoadingImg(el);
      //根据binding.value的值，决定创建或者删除img元素
      if (binding.value) {
          // 判断loading效果的img元素是否存在
          if (!curImg) {
              //创建该元素
              const loadingImg = createLoadingImg();
              //把创建好的元素加入到dom元素中
              el.appendChild(loadingImg)
          }
      } else {
          //如果binding.value值为false或者不存在
          //判断是否有loadingImg元素
          if(curImg){
              //移除loadingImg元素
              curImg.remove()
          }
      }
  }
  //由于bind和update钩子函数的作用都是根据binding.value的值，决定创建或删除img元素所以就合并为一起
  // export default {
  //     bind(el,binding){
  //         // 根据binding.value的值，决定创建或删除img元素
  //     },
  //     update(el,binding){
  //         // 根据binding.value的值，决定创建或删除img元素
  //     }
  // }